// Global Instructions Rule Applied!
//
// Clearable hex colour picker used for pipeline/stage threshold colours.
// Emits a 6-digit #RRGGBB string (alpha disabled to satisfy the DB CHECK) or
// null when cleared — null means "no colour", so the band falls back to a
// sensible default on the card.
import React from 'react'
import { ColorPicker } from 'antd'

interface ColourPickerFieldProps {
  value: string | null
  onChange: (hex: string | null) => void
}

// Quick-pick swatches shown in the picker. "Alert states" are the recommended
// warn/critical band colours; "Standard" is the Ant Design preset palette plus
// greys, for a consistent range of standard colours to choose from.
const COLOUR_PRESETS = [
  {
    label: 'Alert states',
    colors: ['#faad14', '#d97706', '#fa8c16', '#ff4d4f', '#dc2626', '#fa541c', '#52c41a']
  },
  {
    label: 'Standard',
    defaultOpen: true,
    colors: [
      '#f5222d',
      '#fa541c',
      '#fa8c16',
      '#faad14',
      '#fadb14',
      '#a0d911',
      '#52c41a',
      '#13c2c2',
      '#1677ff',
      '#2f54eb',
      '#722ed1',
      '#eb2f96',
      '#000000',
      '#595959',
      '#8c8c8c',
      '#bfbfbf'
    ]
  }
]

export default function ColourPickerField({ value, onChange }: ColourPickerFieldProps): React.ReactElement {
  return (
    <ColorPicker
      allowClear
      disabledAlpha
      format="hex"
      size="small"
      presets={COLOUR_PRESETS}
      value={value || undefined}
      onChangeComplete={(c) => onChange(c.toHexString())}
      onClear={() => onChange(null)}
    />
  )
}
